import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TransferUnit } from '@app/models/inventory/transfer-unit';

import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({ providedIn: 'root' })
export class TransferUnitProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.inventoryApi + '/api/v1/transfer-unit';

  public getTransferUnitsForRollNumbers(rollNumbers: string[]): Observable<ApiResponse<TransferUnit[]>> {
    return this.httpClient.post<ApiResponse<TransferUnit[]>>(`${this.baseUrl}/batch/roll-numbers`, rollNumbers);
  }
}
